// Module
var code = `<div class="flex-horizontal">
    <div>
        <div class="checkbox">
            <input data-bind="attr: { id: 'dont-show-' + hint.id }, checked: hint.dontShowAgain" class="styled" type="checkbox">
            <label data-bind="attr: { for: 'dont-show-' + hint.id }">
                Don't show again
            </label>
        </div>
    </div>
    <div class="flex-separator"></div>
    <div>
        <button type="button" class="btn btn-default" data-bind="click: close" title="Close this dialog">
            <i class="icon-cancel"></i><span>Close</span>
        </button>
        <button type="button" class="btn btn-primary" data-bind="click: dismiss" title="Dismiss this alert">
            <i class="icon-dismiss-all"></i><span>Dismiss alert</span>
        </button>
    </div>
</div>`;
// Exports
export default code;